import { ThemeConfig } from "antd";

export const ANTD_THEME_GLOBAL_TOKEN: ThemeConfig = {
    components: {
      Spin: {
        colorPrimary: '#66B28A',
      },
      Button: {
        // colorBgBase: '#66B28A',
        colorPrimary: '#66B28A',
        colorPrimaryHover: "#5AA57D",
        colorPrimaryActive: "#478965",
      },
      Switch: {
        colorPrimary: '#66B28A',
        colorPrimaryHover: '#66B28A',
      },
      Checkbox: {
        colorPrimary: '#66B28A',
        colorPrimaryHover: '#66B28A',
      },
      Radio: {
        colorPrimary: '#007E3C',
      },
    },
  }